
import { toTitleCase } from "@lovetoknow/love-utils-js";
import { UiCard, UiCardTitle, UiCardBody } from "@lovetoknow/ui-card";

export default {
	name: "WordCard",
	components: {
		UiCard,
		UiCardTitle,
		UiCardBody,
	},
	props: {
		word: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			isMultiLine: false,
			isOpen: false,
		};
	},
	computed: {
		title() {
			const source = this.word.headword || this.word.slug;
			return toTitleCase(source);
		},
		url() {
			return `//www.yourdictionary.com/${this.word.slug}`;
		},
		badgeLabel() {
			if (
				["verb", "noun", "adjective", "adverb"].includes(this.word.pos)
			) {
				return this.word.pos;
			}

			return null;
		},
		badgeColour() {
			switch (this.badgeLabel) {
				case "verb":
					return "#f1f0fa";
				case "noun":
					return "#fff7d4";
				case "adjective":
					return "#d3fff5";
				case "adverb":
					return "#d3fff5";
			}

			return null;
		},
		hasBadge() {
			return this.badgeLabel !== null;
		},
	},
	mounted() {
		const lineCount = this.$refs.definition?.getClientRects?.().length || 1;
		this.isMultiLine = lineCount > 1;
	},
	methods: {
		onToggleExpand() {
			this.isOpen = !this.isOpen;
		},
	},
};
